/* eslint-disable react-hooks/exhaustive-deps */
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	SimpleGrid,
	Box,
	Text,
	Wrap,
	WrapItem,
	Avatar,
	Spacer,
	IconButton,
	useToast,
	HStack,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import Popover from '@cloudscape-design/components/popover';
import ListLoading from '../ListLoading';
import useStore from '../../store';
import SelectUserModal from '../Modal/SelectUserModal';
import c from '../../constant';

const Q_OFFICES = gql`
	query getUserAssignsByOffices($permission: String!, $department: String!) {
		getUserAssignsByOffices(permission: $permission, department: $department)
	}
`;

const M_ASSIGN = gql`
	mutation assignUserToUserAssign($type: String!, $userId: String!, $permission: String!) {
		assignUserToUserAssign(type: $type, userId: $userId, permission: $permission)
	}
`;

const M_REMOVE = gql`
	mutation removeUserFromUserAssign($type: String!, $userId: String!, $permission: String!) {
		removeUserFromUserAssign(type: $type, userId: $userId, permission: $permission)
	}
`;

function OfficeSelectModal({ permission = null, department = null, isOpen = false, onClose = () => null, onCallback = (office) => null }) {
	const toast = useToast();
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [office, setOffice] = useState(null);
	const [fetchData, { loading, data }] = useLazyQuery(Q_OFFICES);
	const [addUser] = useMutation(M_ASSIGN);
	const [removeUser] = useMutation(M_REMOVE);

	useEffect(() => permission && department && load(), [permission, department]);

	function load() {
		fetchData({ variables: { permission, department } });
	}

	return (
		<>
			<Modal isOpen={isOpen} size="2xl" trapFocus={false} onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>{t('Please select office')}</ModalHeader>
					<ModalCloseButton isDisabled={false} />
					<ModalBody>
						<ListLoading loading={loading} loadedList={data?.getUserAssignsByOffices} animation={false}>
							{({ loadedList }) => (
								<SimpleGrid columns={[1, null, 2]} spacing={4}>
									{loadedList?.map((e, i) => (
										<Box key={i} _hover={{ backgroundColor: 'gray.50' }} p={4} borderWidth={1} borderColor="gray.300">
											<Text
												_hover={{ cursor: 'pointer', color: e?.users?.length > 0 ? 'blue.700' : 'blue.100' }}
												fontSize="md"
												fontWeight="600"
												textDecoration="underline"
												color={e?.users?.length > 0 ? 'blue.500' : 'blue.100'}
												onMouseDown={() => {
													if (e?.users?.length === 0) {
														toast({
															title: t('No user has been added'),
															status: 'warning',
															isClosable: true,
															position: 'bottom',
														});
													} else {
														onCallback(e);
														onClose();
													}
												}}
											>
												{lang === 'kh' ? t(e?.labelKh) : t(e?.label)}
											</Text>
											<Spacer height={4} />
											<Wrap spacing={2}>
												{e?.users?.map((el, i) => (
													<WrapItem key={i} alignItems="center">
														<Popover
															dismissButton={false}
															position="bottom"
															size="small"
															triggerType="custom"
															content={
																<HStack spacing={0}>
																	<Text>
																		{lang === 'kh' ? el?.fullNameKhmer || el?.fullName : el?.fullName || el?.fullNameKhmer}
																	</Text>
																	<IconButton
																		_focus={{ boxShadow: 'none' }}
																		size="sm"
																		icon={
																			<DeleteIcon
																				fontSize="14px"
																				color="red.500"
																				_hover={{ cursor: 'pointer', color: 'red.600' }}
																			/>
																		}
																		variant="unstyled"
																		onMouseDown={() => {
																			removeUser({ variables: { type: 'office', userId: el?.id, permission } })
																				.then(({ data }) => {
																					load();
																				})
																				.catch((error) => {
																					toast({
																						title: t(error?.message ? error?.message : 'something went wrong'),
																						status: 'error',
																						isClosable: true,
																						position: 'bottom-right',
																					});
																				});
																		}}
																	/>
																</HStack>
															}
														>
															<Avatar
																cursor="pointer"
																size="xs"
																name={
																	lang === 'kh'
																		? el?.fullNameKhmer || el?.fullName || el?.username
																		: el?.fullName || el?.fullNameKhmer || el?.username
																}
																src={el?.avatar?.icon ? c.baseFilePath + el?.avatar?.icon : null}
															/>
														</Popover>
													</WrapItem>
												))}
												<WrapItem alignItems="center">
													<IconButton
														_focus={{ boxShadow: 'none' }}
														icon={<AddIcon color="blue.500" _hover={{ color: 'blue.700' }} />}
														variant="unstyled"
														minWidth="24px"
														width="24px"
														height="32px"
														onMouseDown={() => setOffice(e?.value)}
													/>
												</WrapItem>
											</Wrap>
										</Box>
									))}
								</SimpleGrid>
							)}
						</ListLoading>
					</ModalBody>
					<ModalFooter></ModalFooter>
				</ModalContent>
			</Modal>
			<SelectUserModal
				role={permission}
				callback={(e) => {
					addUser({ variables: { type: 'office', userId: e?.id, permission } })
						.then(({ data }) => {
							load();
						})
						.catch((error) => {
							toast({
								title: t(error?.message ? error?.message : 'something went wrong'),
								status: 'error',
								isClosable: true,
								position: 'bottom-right',
							});
						});
				}}
				isOpen={office ? true : false}
				onClose={() => setOffice(null)}
				departments={department}
				offices={office}
			/>
		</>
	);
}

export default OfficeSelectModal;
